import type { TableColumnVisibility, TableEndpoint } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { makeIsColumnVisible } from 'components/Table/helpers/makeIsColumnVisible';
import { array } from 'fp-ts';
import { identity, pipe } from 'fp-ts/lib/function';
import { distinct } from 'utils/array/distinct';

export const getVisibleColumnsDependencies = <TRow,>(
  columnVisibility: TableColumnVisibility | undefined,
  endpoint: TableEndpoint<TRow>,
  rowIdField: string | undefined,
): (keyof TRow)[] => {
  const isColumnVisible = makeIsColumnVisible(columnVisibility);

  return pipe(
    endpoint.columns,
    array.filter(isColumnVisible),
    array.chain(prop('webDependencies')),
    array.concat((endpoint.webDependencies as (keyof TRow)[]) ?? []),
    rowIdField !== undefined
      ? array.append(rowIdField as keyof TRow)
      : identity,
    distinct,
  );
};
